<template>
    <el-col :span="16">
        <el-card class="box-card" style="height:440px;" v-loading="loading">
            <div slot="header" class="clearfix">
                <span>PUE &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 选择周时默认所选日期往前推七天作为本周</span>
                <el-popover
                        placement="top"
                        title=""
                        width="200"
                        trigger="hover"
                        content="汇总统计所有数据中心的抄表数据">
                    <el-button slot="reference" type="text" style="float:right;padding: 3px 0;color:#666;"><i class='el-icon-question'></i></el-button>
                </el-popover>
                <div class="float-r" v-show="false">
                    <span class="grey-font font-12" v-if="'week'==searchType">默认所选日期往前推7天作为本周&nbsp;&nbsp;</span>
                    <el-select v-model="searchType" placeholder="按照周" size="small" @change="weekAndMonthChangeFun" style="margin-top:-6px;margin-right:5px;">
                        <el-option
                                v-for="item in weekAndMonth"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <el-date-picker v-if="searchType=='week'"
                            v-model="searchDate"
                            size="small"
                            @change="dataChange"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :editable="false"
                            :clearable="false"
                            placeholder="选择日期" style="margin-top:-6px;width:240px;">
                    </el-date-picker>


                    <el-date-picker  v-if="searchType=='month'"
                            size="small"
                            v-model="searchMouth"
                            type="month"
                            @change="mouthChange"
                            value-format="yyyy-MM"
                            :editable="false"
                            :clearable="false"
                            placeholder="选择月" style="margin-top:-6px;width:240px;" >
                    </el-date-picker>

                    </div>

                </div>
            </div>
            <div class="blocktab">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="环比" name="first">
                        <div :key="tabKey" id="puehuang" style="height:250px;width:100%;" ></div>
                    </el-tab-pane>
                    <el-tab-pane label="同比" name="second">
                        <div :key="tabKey" id="puetong" style="height:250px;width:100%;" ></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>

    </el-col>
</template>


<script>
    import {athubAxios} from '../../../../util'
    import {COMMON_SERVER} from '@/api/server'
    import * as echarts from 'echarts';

    import {queryPueBySysRooms
    } from '@/api/bossBoard/pueAndAllRound/pueSituation.js'

    let that;
    export default {
        name: 'pueSituation',
        components: {},

        data() {
            return {
                tabKey: '',

                searchType:'month',
                searchDate:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1)+ '-'+new Date().getDate(),
                searchMouth:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1),
                weekAndMonth:[{
                    'label':'周',
                    'value':'week'
                },{
                    'label':'月',
                    'value':'month'
                }],
                activeName:'first',
                sysRooms:[],//数组 父页面选择园区（部门）之后查询得到得对应得数据中心集合ID，由父页面传值进来
                //PUE 数据MAP 供根据sysRoomId获取对应的数据中心名称
                sysRoomMap:null,
                loading:true
            }
        },
        methods: {
            eqReturnInfo(info){
                let value = '';
                this.weekAndMonth.forEach(e=>{
                    if(info==e.value){
                        value = e.label;
                    }
                });
                return value;
            },
            handleClick(tab){
                this.tabKey = tab;
                this.weekAndMonthChangeFun(false);
            },
            //周月下拉框促发事件
            async weekAndMonthChangeFun(boo){
                this.loading=true;
                //周月下拉框缩起来促发事件
//                if (boo == false) {
                    if(this.searchType=='week'){//周

                        //环比  上周和这周
                        var date=new Date(this.searchDate);

                        var topWeekOld=new Date(date);//上周最后一天
                        topWeekOld.setDate(topWeekOld.getDate()-7);
                        var topWeekFirst=new Date(topWeekOld);//上周第一天
                        topWeekFirst.setDate(topWeekFirst.getDate()-6);

                        var thisWeekFirst=new Date(date);//本周第一天
                        thisWeekFirst.setDate(thisWeekFirst.getDate()-6);
                        //本周最后一天其实就是this.searchDate

                        var topWeekOldStr=topWeekOld.getFullYear()+'-'+this.addZero(topWeekOld.getMonth()+1)+'-'+this.addZero(topWeekOld.getDate());
                        var topWeekFirstStr=topWeekFirst.getFullYear()+'-'+this.addZero(topWeekFirst.getMonth()+1)+'-'+this.addZero(topWeekFirst.getDate());

                        var thisWeekFirstStr=thisWeekFirst.getFullYear()+'-'+this.addZero(thisWeekFirst.getMonth()+1)+'-'+this.addZero(thisWeekFirst.getDate());
                        var thisWeekOldStr=date.getFullYear()+'-'+this.addZero(date.getMonth()+1)+'-'+this.addZero(date.getDate());
                        //上周
                        var topWeekArray=await queryPueBySysRooms(this.sysRooms,topWeekFirstStr,topWeekOldStr);
                        //本周
                        var thisWeekArray=await queryPueBySysRooms(this.sysRooms,thisWeekFirstStr,thisWeekOldStr);

                        var topWeekArrayNew=this.sumByRoomIdCompute(topWeekArray);
                        var thisWeekArrayNew=this.sumByRoomIdCompute(thisWeekArray);

                        var arraySysRoomName=[];//echarts第一个参数
                        var thisWeekInfos=[];//echarts第二个参数
                        var topWeekInfos=[];//echarts第三个参数
                        for(var a=0;a<this.sysRooms.length;a++){
                            arraySysRoomName[a]=this.sysRoomMap.get(this.sysRooms[a]+'');
                            topWeekInfos[a]=0;
                            thisWeekInfos[a]=0;
                            topWeekArrayNew.forEach(e =>{
                                if(this.sysRooms[a]==e.roomId){
                                    topWeekInfos[a]=(e.pueAmountNew=='NaN'?0:e.pueAmountNew);
                                }
                            })
                            thisWeekArrayNew.forEach(h =>{
                                if(this.sysRooms[a]==h.roomId){
                                    thisWeekInfos[a]=(h.pueAmountNew=='NaN'?0:h.pueAmountNew);
                            }
                        })
                        }

                        //赋值ECHARTS
                        this.setHuangEcharts(arraySysRoomName,thisWeekInfos,topWeekInfos);



                        // 同比 去年周和今年周
                        var date1=new Date(this.searchDate);

                        var topWeekOld1=new Date(date1);//去年这周最后一天
                        topWeekOld1.setFullYear(topWeekOld1.getFullYear()-1);
                        var topWeekFirst1=new Date(topWeekOld1);//去年这周第一天
                        topWeekFirst1.setDate(topWeekFirst1.getDate()-6);

                        var thisWeekFirst1=new Date(date1);//本周第一天
                        thisWeekFirst1.setDate(thisWeekFirst1.getDate()-6);
                        //本周最后一天其实就是this.searchDate

                        var topWeekOldStr1=topWeekOld1.getFullYear()+'-'+this.addZero(topWeekOld1.getMonth()+1)+'-'+this.addZero(topWeekOld1.getDate());
                        var topWeekFirstStr1=topWeekFirst1.getFullYear()+'-'+this.addZero(topWeekFirst1.getMonth()+1)+'-'+this.addZero(topWeekFirst1.getDate());

                        var thisWeekFirstStr1=thisWeekFirst1.getFullYear()+'-'+this.addZero(thisWeekFirst1.getMonth()+1)+'-'+this.addZero(thisWeekFirst1.getDate());
                        var thisWeekOldStr1=date1.getFullYear()+'-'+this.addZero(date1.getMonth()+1)+'-'+this.addZero(date1.getDate());
                        //上周
                        var topWeekArray1=await queryPueBySysRooms(this.sysRooms,topWeekFirstStr1,topWeekOldStr1);
                        //本周
                        var thisWeekArray1=await queryPueBySysRooms(this.sysRooms,thisWeekFirstStr1,thisWeekOldStr1);

                        var topWeekArrayNew1=this.sumByRoomIdCompute(topWeekArray1);
                        var thisWeekArrayNew1=this.sumByRoomIdCompute(thisWeekArray1);

                        var arraySysRoomName1=[];//echarts第一个参数
                        var thisWeekInfos1=[];//echarts第二个参数
                        var topWeekInfos1=[];//echarts第三个参数
                        for(var a=0;a<this.sysRooms.length;a++){
                            arraySysRoomName1[a]=this.sysRoomMap.get(this.sysRooms[a]+'');
                            topWeekInfos1[a]=0;
                            thisWeekInfos1[a]=0;
                            topWeekArrayNew1.forEach(e =>{
                                if(this.sysRooms[a]==e.roomId){
                                topWeekInfos1[a]=e.pueAmountNew=='NaN'?0:e.pueAmountNew;
                            }
                        })
                            thisWeekArrayNew1.forEach(h =>{
                                if(this.sysRooms[a]==h.roomId){
                                thisWeekInfos1[a]=h.pueAmountNew=='NaN'?0:h.pueAmountNew;
                            }
                        })
                        }

                        //elementui  针对tab里面的echarts第二个渲染宽度获取不到问题，改用setTimeout
                        setTimeout(() => {
                            this.setTongEcharts(arraySysRoomName1,thisWeekInfos1,topWeekInfos1);
                        },1000)

                    }else{//月

                        //环比  上月和这月
                        var date=new Date(this.searchMouth);
                        date.setMonth(date.getMonth()-1);

                        //上月第一天
                        var topMonthFirst = new Date(this.getTheMonthFirstLastDay(date.getFullYear()+'-'+this.addZero(date.getMonth()+1) + "-01", (
                                'yyyy-MM-dd'))[0]);
                        //上月最后一天
                        var topMonthOld = new Date(this.getTheMonthFirstLastDay(date.getFullYear()+'-'+this.addZero(date.getMonth()+1) + "-01", (
                                'yyyy-MM-dd'))[1]);


                        //本月第一天
                        var thisMonthFirst = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[0]);
                        //本月最后一天
                        var thisMonthOld = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1]);


                        var topMonthOldStr=topMonthOld.getFullYear()+'-'+this.addZero(topMonthOld.getMonth()+1)+'-'+this.addZero(topMonthOld.getDate());
                        var topMonthFirstStr=topMonthFirst.getFullYear()+'-'+this.addZero(topMonthFirst.getMonth()+1)+'-'+this.addZero(topMonthFirst.getDate());

                        var thisMonthFirstStr=thisMonthFirst.getFullYear()+'-'+this.addZero(thisMonthFirst.getMonth()+1)+'-'+this.addZero(thisMonthFirst.getDate());
                        var thisMonthOldStr=thisMonthOld.getFullYear()+'-'+this.addZero(thisMonthOld.getMonth()+1)+'-'+this.addZero(thisMonthOld.getDate());
                        //上月
                        var topMonthArray=await queryPueBySysRooms(this.sysRooms,topMonthFirstStr,topMonthOldStr);
                        //本月
                        var thisMonthArray=await queryPueBySysRooms(this.sysRooms,thisMonthFirstStr,thisMonthOldStr);


                        var topMonthArrayNew=this.sumByRoomIdCompute(topMonthArray);
                        var thisMonthArrayNew=this.sumByRoomIdCompute(thisMonthArray);

                        var arraySysRoomName=[];//echarts第一个参数
                        var thisMonthInfos=[];//echarts第二个参数
                        var topMonthInfos=[];//echarts第三个参数
                        for(var a=0;a<this.sysRooms.length;a++){
                            arraySysRoomName[a]=this.sysRoomMap.get(this.sysRooms[a]+'');
                            topMonthInfos[a]=0;
                            thisMonthInfos[a]=0;
                            topMonthArrayNew.forEach(e =>{
                                if(this.sysRooms[a]==e.roomId){
                                topMonthInfos[a]=e.pueAmountNew=='NaN'?0:e.pueAmountNew;
                            }
                        })
                            thisMonthArrayNew.forEach(h =>{
                                if(this.sysRooms[a]==h.roomId){
                                thisMonthInfos[a]=h.pueAmountNew=='NaN'?0:h.pueAmountNew;
                            }
                        })
                        }

                        //赋值ECHARTS
                        this.setHuangEcharts(arraySysRoomName,thisMonthInfos,topMonthInfos);



                        // 同比 去年月和今年月
                        var date1=new Date(this.searchMouth);

                        date1.setFullYear(date1.getFullYear()-1);//去年这个月

                        //去年这个月第一天
                        var topMonthFirst1 = new Date(this.getTheMonthFirstLastDay(date1.getFullYear()+'-'+this.addZero(date1.getMonth()+1) + "-01", (
                                'yyyy-MM-dd'))[0]);
                        //去年这个月最后一天
                        var topMonthOld1 = new Date(this.getTheMonthFirstLastDay(date1.getFullYear()+'-'+this.addZero(date1.getMonth()+1) + "-01", (
                                'yyyy-MM-dd'))[1]);


                        //本月第一天
                        var thisMonthFirst1 = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[0]);
                        //本月最后一天
                        var thisMonthOld1 = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1]);


                        var topMonthOldStr1=topMonthOld1.getFullYear()+'-'+this.addZero(topMonthOld1.getMonth()+1)+'-'+this.addZero(topMonthOld1.getDate());
                        var topMonthFirstStr1=topMonthFirst1.getFullYear()+'-'+this.addZero(topMonthFirst1.getMonth()+1)+'-'+this.addZero(topMonthFirst1.getDate());

                        var thisMonthFirstStr1=thisMonthFirst1.getFullYear()+'-'+this.addZero(thisMonthFirst1.getMonth()+1)+'-'+this.addZero(thisMonthFirst1.getDate());
                        var thisMonthOldStr1=thisMonthOld1.getFullYear()+'-'+this.addZero(thisMonthOld1.getMonth()+1)+'-'+this.addZero(thisMonthOld1.getDate());
                        //去年月
                        var topMonthArray1=await queryPueBySysRooms(this.sysRooms,topMonthFirstStr1,topMonthOldStr1);
                        //本月
                        var thisMonthArray1=await queryPueBySysRooms(this.sysRooms,thisMonthFirstStr1,thisMonthOldStr1);

                        var topMonthArrayNew1=this.sumByRoomIdCompute(topMonthArray1);
                        var thisMonthArrayNew1=this.sumByRoomIdCompute(thisMonthArray1);

                        var arraySysRoomName1=[];//echarts第一个参数
                        var thisMonthInfos1=[];//echarts第二个参数
                        var topMonthInfos1=[];//echarts第三个参数
                        for(var a=0;a<this.sysRooms.length;a++){
                            arraySysRoomName1[a]=this.sysRoomMap.get(this.sysRooms[a]+'');
                            topMonthInfos1[a]=0;
                            thisMonthInfos1[a]=0;
                            topMonthArrayNew1.forEach(e =>{
                                if(this.sysRooms[a]==e.roomId){
                                topMonthInfos1[a]=e.pueAmountNew=='NaN'?0:e.pueAmountNew;
                            }
                        })
                            thisMonthArrayNew1.forEach(h =>{
                                if(this.sysRooms[a]==h.roomId){
                                thisMonthInfos1[a]=h.pueAmountNew=='NaN'?0:h.pueAmountNew;
                            }
                        })
                        }

                        //elementui  针对tab里面的echarts第二个渲染宽度获取不到问题，改用setTimeout
                        setTimeout(() => {
                            this.setTongEcharts(arraySysRoomName1,thisMonthInfos1,topMonthInfos1);
                    },1000)

                    }
//                }
                this.loading=false;
            },
            //时间控件促发事件
            dataChange(){
                this.weekAndMonthChangeFun(false);
            },
            //月份控件促发事件
            mouthChange(){
                this.weekAndMonthChangeFun(false);
            },
            addZero(num) {
                if (parseInt(num) < 10) {
                    num = '0' + num;
                }
                return num;
            },
            //根据roomId计算总和
            sumByRoomIdCompute(array){
                //排序
                var dcnumGroupedTotalInfo =array.sort(this.compareInfo("roomId"));
                //分组
                var map = new Map();
                for(var n=0;n<dcnumGroupedTotalInfo.length;n++){
                    if(map.get(dcnumGroupedTotalInfo[n].roomId)){
                        var value=map.get(dcnumGroupedTotalInfo[n].roomId);
                        var dcnumGroupedTotalInfoNew=dcnumGroupedTotalInfo[n];
                        //相同的roomId相加
                        value.recordITAmount=value.recordITAmount+dcnumGroupedTotalInfoNew.recordITAmount;
                        value.recordRoomAmount=value.recordRoomAmount+dcnumGroupedTotalInfoNew.recordRoomAmount;
                        var sysRoomName=this.sysRoomMap.get(value.roomId);
                        value.sysRoomName=sysRoomName;
                        map.set(value.roomId,value);
                    }else{
                        var dcnumGroupedTotalInfoNew=JSON.parse(JSON.stringify(dcnumGroupedTotalInfo[n]));
                        var sysRoomName=this.sysRoomMap.get(dcnumGroupedTotalInfoNew.roomId);
                        dcnumGroupedTotalInfoNew.sysRoomName=sysRoomName;
                        map.set(dcnumGroupedTotalInfo[n].roomId,dcnumGroupedTotalInfoNew);
                    }
                }
                //map转集合
                var roomIdGroupedTotalInfo=[...map.values()];
                //在循环一次计算recordITAmount/recordRoomAmount得到pue的值,值越小越靠前
                roomIdGroupedTotalInfo.forEach(e =>{
                    e.pueAmountNew=(e.recordRoomAmount/e.recordITAmount).toFixed(2);
                })

                roomIdGroupedTotalInfo=roomIdGroupedTotalInfo.sort(this.compareInfo("roomId"));
                return roomIdGroupedTotalInfo;
            },
            //比较排序
            compareInfo(property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1 - value2;
                }
            },
            //获取当前年月日时间，月出（一号）到月末（31/30号）
            getTheMonthFirstLastDay(dateStr, fmt){
                var date = new Date(dateStr);
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                return [firstDay.Format(fmt), lastDay.Format(fmt)];
            },
            //赋值echarts
            setHuangEcharts(sysRoomNames,thisInfo,topInfo){
                //平均PUE
                var myChart = echarts.init(document.getElementById('puehuang'));
                var option = {

                    title: {
                        text: '各数据中心'+this.eqReturnInfo(this.searchType)+'平均PUE环比情况',
                        textStyle: {
                            align: 'center',
                            color: '#000',
                            fontSize: 14,
                        },
                        top: '0',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['本'+this.eqReturnInfo(this.searchType)+'平均PUE', '上'+this.eqReturnInfo(this.searchType)+'平均PUE'],
                        right: 10,
                        top: 10
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        xAxisIndex: [0],
                        end: 100
                    },
                        {
                            type: 'inside',
                            xAxisIndex: [0],
                            start: 0,
                            end: 100
                        },

                    ],
                    yAxis: {
                        type: 'value'
                    },
                    xAxis: {
                        type: 'category',
                        data: sysRoomNames,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#333",
                                fontSize: 12
                            },
                            interval: 0,
                            rotate: 30
                        }
                    },
                    series: [
                        {
                            name: '本'+this.eqReturnInfo(this.searchType)+'平均PUE',
                            type: 'bar',
                            stack: '总量',

                            color:'#3a98e8',
                            position:'right',
                            label: {
                                show: true,
                                position: 'insideRight'
                            },
                            data: thisInfo
                        },

                        {
                            name: '上'+this.eqReturnInfo(this.searchType)+'平均PUE',
                            type: 'bar',
                            stack: '总量',

                            color:'#3ac0e8',
                            label: {
                                show: true,
                                position: 'insideRight'
                            },
                            data: topInfo
                        }
                    ]
                };
                myChart.setOption(option);
            },
            //赋值echarts
            setTongEcharts(sysRoomNames,thisInfo,topInfo){
                //平均PUE
                var myChart = echarts.init(document.getElementById('puetong'));
                var option = {

                    title: {
                        text: '各数据中心'+this.eqReturnInfo(this.searchType)+'平均PUE同比情况',
                        textStyle: {
                            align: 'center',
                            color: '#000',
                            fontSize: 14,
                        },
                        top: '0',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['本'+this.eqReturnInfo(this.searchType)+'平均PUE', '去年'+this.eqReturnInfo(this.searchType)+'平均PUE'],
                        right: 10,
                        top: 10
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        xAxisIndex: [0],
                        end: 100
                    },
                        {
                            type: 'inside',
                            xAxisIndex: [0],
                            start: 0,
                            end: 100
                        },

                    ],
                    yAxis: {
                        type: 'value'
                    },
                    xAxis: {
                        type: 'category',
                        data: sysRoomNames,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#333",
                                fontSize: 12
                            },
                            interval: 0,
                            rotate: 30
                        }
                    },
                    series: [
                        {
                            name: '本'+this.eqReturnInfo(this.searchType)+'平均PUE',
                            type: 'bar',
                            stack: '总量',

                            color:'#3a98e8',
                            position:'right',
                            label: {
                                show: true,
                                position: 'insideRight'
                            },
                            data: thisInfo
                        },

                        {
                            name: '去年'+this.eqReturnInfo(this.searchType)+'平均PUE',
                            type: 'bar',
                            stack: '总量',

                            color:'#3ac0e8',
                            label: {
                                show: true,
                                position: 'insideRight'
                            },
                            data: topInfo
                        }
                    ]
                };
                myChart.setOption(option);
            }

        },
        created(){



        },
        mounted() {


        },
        computed: {

        },

    }
</script>